<template>
    <collapse-transition>
        <div class="radio-selector" v-show="currentVisible" @scroll.stop="handleScroll"  @touchmove.stop="handleScroll">
            <div class="radio-selector-item"
            @click.stop="handleSelectItem(item)"
            v-for="item in data"
            :class="{active: currentValue[valueKey] === item[valueKey]}"
            :key="item[valueKey]">
                <span>{{item[labelKey]}}</span>
                <i v-if="currentValue[valueKey] === item[valueKey]" class="jc-icon icon-correct"></i>
            </div>
        </div>
    </collapse-transition>
</template>

<script>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// 时间原因，简单处理，组件设计的不是很好
export default {
  name: 'radio-selector',
  components: {
    CollapseTransition
  },
  props: {
    visible: Boolean,
    data: {
      type: Array,
      default () {
        return []
      }
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    labelKey: {
      type: String,
      default: 'label'
    }
  },
  data () {
    return {
      currentVisible: false,
      currentValue: undefined
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler () {
        this.currentVisible = this.visible
      }
    },
    currentVisible () {
      this.$emit('update:visible', this.currentVisible)
    },
    value: {
      immediate: true,
      deep: true,
      handler () {
        this.currentValue = this.value
      }
    }
  },
  methods: {
    handleSelectItem (item) {
      this.currentValue = JSON.parse(JSON.stringify(item))
      setTimeout(() => {
        this.currentVisible = false
        this.$emit('input', this.currentValue)
        this.$emit('change', this.currentValue)
      }, 100)
    },
    handleScroll (e) {
      e.preventDefault()
      e.stopPropagation()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variable.scss';
@import '@/assets/scss/mixins.scss';
.radio-selector {
  position: absolute;
  width: 750px;
  background: #fff;
  transition: height .3s linear;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 2000;
  top: 100%;
  padding-bottom: 18px;
  left: 0;
//   max-height: 100px;
  &-item {
    padding: 18px 30px;
    line-height: 24px;
    font-size: 24px;
    width: 100%;
    overflow: hidden;
    display: inline-block;
    padding-right: 30px;
    // display: flex;
    // align-items: center;
    @include clearfix;
    span {
      float: left;
    }
    i {
      float: right;
      // position: absolute;
      // right: 30px;
      // top: 50%;
      // transform: translateY(-50%);
    }
    &.active {
      color: #409bff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/radio-selector/index.vue